/**
 * @description
 * Main layout component that wraps all protected pages.
 * Includes header, footer, and main content area.
 *
 * @author AI Developer <ai@byteable.ai>
 * @date 2025-01-06
 * @see admin/src/frontend/components/Layout/index.test.tsx
 */

import { Outlet } from 'react-router';
import { Header } from './Header';
import { Footer } from './Footer';

/**
 * Layout component with header, content area, and footer
 */
export function Layout() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">
        <div className="container mx-auto px-4 py-6 max-w-7xl">
          <Outlet />
        </div>
      </main>
      <Footer />
    </div>
  );
}

/*
 * © 2025 Byte Inc. All rights reserved.
 * This code is the confidential and proprietary information of Byte Inc.
 * You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Byte Inc.
 */